var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccelerometer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 67 53",
    style: {
      enableBackground: "new 0 0 67 53"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.1,42.6c-5.8-1.3-9-2.2-9.6-3.6c-0.9-2.1-0.3-6.9,0.6-14.1l0.1-1.5l0,0l2.2,0.5c0.7,0.2,1.4-0.4,1.2-1.2L9.4,12 c-0.2-0.8-1.2-1.1-1.7-0.5l-7.2,8.2C0,20.3,0.3,21.1,1,21.3l2.3,0.8c-0.1,0.3,0-0.3,0,0L3,24.2C0.8,41.7,0.5,45.5,15.6,48.9l0,0 c1.7,0.4,3.5-0.7,3.9-2.4l0,0C19.9,44.7,18.8,43,17.1,42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M66.1,33.1l-2.2-0.7c3.2-15,4.5-23.5-11.5-27.9c-1.7-0.5-3.5,0.5-4,2.3s0.5,3.5,2.3,4c9.7,2.7,11.3,5.1,8.2,20.3l-2.2-0.5 c-0.7-0.2-1.4,0.4-1.2,1.2l2.2,10.7c0.2,0.8,1.2,1.1,1.7,0.5l7.2-8.2C67.1,34.2,66.8,33.3,66.1,33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M56.9,23.2c-0.4-1.6-1.6-2.8-3.2-3c-1.2-0.2-3.2-1-6-3.6c-2.2-2.1-2.6-5.3-2.8-7.6c-0.1-1.9-1.5-3.5-3.4-3.9h-0.1 c-1.3-0.2-2.7,0.2-3.6,1.1c-1,1-3.7,3.4-6.7,3.8c-2.7,0.4-5.8-0.8-7.5-1.6s-3.7-0.4-5,0.9l0,0c-1,1-1.3,2.5-0.8,4.1 c0.3,1,1.2,4.6-0.4,7.9c-1.1,2.3-3.2,4.1-4.7,5.2c-1.7,1.2-2.3,2.9-1.8,4.8c0.5,1.9,2.1,2.8,3.5,3c0.7,0.1,2.1,0.3,5.1,2.9 c2.9,2.5,3.2,6.4,3.2,7.6c0.1,1.8,0.9,3.3,2.3,4c0.5,0.3,1.1,0.4,1.7,0.4c1.2,0,2.5-0.6,3.3-1.4c0.9-1,1.7-1.6,2.4-2.1 c0.9-0.6,1.8-1,2.3-1.1c1-0.2,1.5-0.7,1.8-1.2c0.5,0.4,1.2,0.7,1.9,0.6c0.2,0,0.9,0,2.6,0.3c0.9,0.2,1.7,0.5,2.4,0.9 c0.2,0.1,0.4,0.2,0.5,0.2c2.5,1.1,4.2,0.1,5-0.5c1.1-0.9,1.5-2.4,1.1-3.8c-0.4-1.3-1.2-4.7,0.2-8.1c1-2.6,3-4.2,4.7-5.4 C56.5,26.6,57.3,25,56.9,23.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccelerometer);
export default __webpack_public_path__ + "static/media/accelerometer.4db288d4aa46e1511743ba512d2b5af9.svg";
export { ForwardRef as ReactComponent };